import React from 'react';
import './LoadingBar.css';

const LoadingBar = () => {
  return (
    <div className="loading-bar">
      <div className="loading-bar-inner"></div>
    </div>
  );
};

export default LoadingBar;